import React, { useMemo, useState } from 'react';

// columns: [{ key, label, render?(row) }]. Daca "render" lipseste, afiseaza row[key].
// Filtrarea si sortarea lucreaza pe row[key] (text). Pentru coloane calculate
// (ex: butoane de actiuni), pune filterable:false.
export default function FilterableTable({ columns, rows, rowKey = 'id', rowClassName }) {
  const [filtre, setFiltre] = useState({});
  const [sortare, setSortare] = useState({ key: null, directie: 1 });

  const randuri = useMemo(() => {
    let r = rows;
    Object.entries(filtre).forEach(([key, val]) => {
      if (!val) return;
      r = r.filter(row => String(row[key] ?? '').toLowerCase().includes(val.toLowerCase()));
    });
    if (sortare.key) {
      r = [...r].sort((a, b) => {
        const av = a[sortare.key], bv = b[sortare.key];
        if (av == null) return 1;
        if (bv == null) return -1;
        if (typeof av === 'number' && typeof bv === 'number') return (av - bv) * sortare.directie;
        return String(av).localeCompare(String(bv)) * sortare.directie;
      });
    }
    return r;
  }, [rows, filtre, sortare]);

  function schimbaSortare(key) {
    setSortare(s => s.key === key ? { key, directie: -s.directie } : { key, directie: 1 });
  }

  return (
    <table className="filterable-table">
      <thead>
        <tr>
          {columns.map(col => (
            <th key={col.key} onClick={() => col.filterable !== false && schimbaSortare(col.key)}
              style={{ cursor: col.filterable !== false ? 'pointer' : 'default' }}>
              {col.label}
              {col.filterable !== false && (
                <span className="sort-icon">
                  {sortare.key === col.key ? (sortare.directie === 1 ? ' \u2191' : ' \u2193') : ' \u21c5'}
                </span>
              )}
            </th>
          ))}
        </tr>
        <tr className="filter-row">
          {columns.map(col => (
            <th key={col.key}>
              {col.filterable !== false && (
                <input
                  placeholder="Filtreaza..."
                  value={filtre[col.key] || ''}
                  onClick={e => e.stopPropagation()}
                  onChange={e => setFiltre({ ...filtre, [col.key]: e.target.value })}
                />
              )}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {randuri.map(row => (
          <tr key={row[rowKey]} className={rowClassName ? rowClassName(row) : ''}>
            {columns.map(col => (
              <td key={col.key}>{col.render ? col.render(row) : row[col.key]}</td>
            ))}
          </tr>
        ))}
        {randuri.length === 0 && (
          <tr><td colSpan={columns.length} style={{ textAlign: 'center', color: '#888' }}>Niciun rezultat.</td></tr>
        )}
      </tbody>
    </table>
  );
}
